import { MailingAddress } from './mailing-address.model';

export class MailingAddressResponse {
  mailingAddress: MailingAddress;
}
